/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CountEmployeeDocumentApprovalRequest = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        count: {
    type: 'number',
    isRequired: true,
},
    },
};